import * as types from './mutation-types'

export const setAlert = async ({ commit }, data) => {
    commit(types.SET_ALERT, data)
}

export const dropAlert = async ({ commit }) => {
    commit(types.DROP_ALERT)
}